'use strict';
module.exports = ['$scope', '$uibModalInstance', 'params'
            , function ($scope, $uibModalInstance, params) {
                $scope.headerMessage=params.headerMessage;
                //$scope.bodyMessage=params.bodyMessage;
                $scope.showCancelButton=params.showCancelButton;                
                $scope.showYesButton=params.showYesButton;
                $scope.cancelButtonText=params.cancelButtonText;
                $scope.yesButtonText=params.yesButtonText;
                $scope.inputText=params.inputText;
                
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.no = function () {
                    $uibModalInstance.dismiss('no');
                };
                $scope.yes = function () {
                     $uibModalInstance.close($scope.inputText);
                };
            }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/modal/modalInputCtrl.js
// module id = 244
// module chunks = 0